import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout'
Vue.use(VueRouter)

const defaultRoute = [
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/errorPage/404'),
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/errorPage/401'),
  },
  {
    path: '/downOlder',
    name: 'downOlder',
    component: () => import('@/views/downOlder/index.vue'),
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/views/message/index.vue'),
    meta: {
      hidden: true
    }
  }
]

export const routes = [
  {
    path: '/',
    redirect: '/member/member-list'
  }
]

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () =>
  new VueRouter({
    routes: [...defaultRoute]
  })

const router = createRouter()

export const resetRouter = () => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export const userRoutes = {
  path: '/member',
  component: Layout,
  redirect: '/member',
  meta: {
    isHome: true,
    title: 'User',
    icon: 'icon iconfont iconProperty1yonghu',
    showChildren: false
  }
}

export const orderRoutes = {
  path: '/systemOrder',
  component: Layout,
  redirect: '/systemOrder',
  meta: {
    isHome: true,
    title: 'Order List',
    icon: 'icon iconfont iconProperty1dingdan',
    showChildren: false
  }
}

export const channelRoutes = {
  path: '/channel',
  component: Layout,
  redirect: '/channel',
  meta: {
    isHome: true, // 加上没有 横杠 样式
    title: 'Channel Level',
    icon: 'icon iconfont icondingdan1',
    showChildren: false
  }
}

export const rankingRoutes = {
  path: '/ranking',
  component: Layout,
  redirect: '/ranking',
  meta: {
    isHome: true,
    title: 'Profit Ranking',
    icon: 'icon iconfont iconProperty1lirun',
    showChildren: false
  }
}

export const warningRoutes = {
  path: '/warningHistory',
  component: Layout,
  redirect: '/warningHistory',
  meta: {
    isHome: true,
    title: 'Warning History',
    icon: 'icon iconfont iconshijian',
    showChildren: false
  }
}

export const orderRiskTagRoutes = {
  path: '/orderRiskTag',
  component: Layout,
  redirect: '/orderRiskTag',
  meta: {
    isHome: true,
    title: 'Order Risk Tag',
    icon: 'icon el-icon-s-order',
    showChildren: false
  }
}

export const ipRoutes = {
  path: '/ip',
  component: Layout,
  redirect: '/ip',
  meta: {
    isHome: true,
    title: 'IP Monitor',
    icon: 'icon iconfont iconjiankongtubiao',
    showChildren: false
  }
}

export const riskyMatchMonitor = {
  path: '/riskyMatchMonitor',
  component: Layout,
  redirect: '/riskyMatchMonitor',
  meta: {
    isHome: true,
    title: 'Match Monitor',
    icon: 'icon iconfont iconProperty1biaoqian',
    showChildren: false
  }
}

export const eventRoutes = {
  path: '/event',
  component: Layout,
  redirect: '/event',
  meta: {
    isHome: true,
    title: 'Event List',
    icon: 'icon iconfont iconProperty1baojing',
    showChildren: false
  }
}

export const riskRoutes = {
  path: '/risk',
  component: Layout,
  redirect: '/risk',
  meta: {
    isHome: true, // 加上没有 横杠 样式
    title: 'User Limit',
    icon: 'icon iconfont iconProperty1shuju',
    showChildren: false
  }
}

export const labelRoutes = {
  path: '/label',
  component: Layout,
  redirect: '/label',
  meta: {
    isHome: true,
    title: 'Label',
    icon: 'icon iconfont iconProperty1biaoqian',
    showChildren: false
  }
}

export const oddsDropTemplateRoutes = {
  path: '/oddsDropTemplate',
  component: Layout,
  redirect: '/oddsDropTemplate',
  meta: {
    isHome: true,
    title: 'oddsDrop Template',
    icon: 'icon iconfont iconProperty1dingdan',
    showChildren: false
  }
}

export const levelRoutes = {
  path: '/level',
  component: Layout,
  redirect: '/level',
  meta: {
    isHome: true,
    title: 'Level',
    icon: 'icon iconfont iconyonghudengji',
    showChildren: false
  }
}


export const logRoutes = {
  path: '/systemlog',
  component: Layout,
  redirect: '/systemlog',
  meta: {
    isHome: true,
    title: 'System Log',
    icon: 'icon iconfont iconProperty1caozuozhuangtai',
    showChildren: false
  }
}



export default router
